import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { IDrug } from '../../types/drug'

export interface IDrugsState extends IAjaxBaseState<IDrug> {
}

const createInitialDrugsState = (): IAjaxBaseState<IDrug> => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialDrugsState
}
